<button mat-stroked-button [ngClass]="buttonClass" matTooltip="Cerrar Sesión" matTooltipPosition="above">
    <mat-icon>exit_to_app</mat-icon>
    <span class="button-text">{{ buttonText }}</span>
</button>